import { render, staticRenderFns } from "./IgGoods.vue?vue&type=template&id=ed3ddc84&scoped=true&"
import script from "./IgGoods.vue?vue&type=script&lang=js&"
export * from "./IgGoods.vue?vue&type=script&lang=js&"
import style0 from "./IgGoods.vue?vue&type=style&index=0&id=ed3ddc84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3ddc84",
  null
  
)

export default component.exports